import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAssetPath } from '../utils/assetHelper';
import './WalletSecurityPage.scss';

// Add Bootstrap type definition
declare global {
  interface Window {
    bootstrap: any;
  }
}

const WalletSecurityPage = () => {
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);

  useEffect(() => {
    // Initialize any needed scripts or plugins for this page
    document.title = 'Wallet Security - Phantom Clash';
    
    // Initialize tooltips
    if (typeof window !== 'undefined' && window.bootstrap) {
      const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new window.bootstrap.Tooltip(tooltipTriggerEl);
      });
    }
  }, []);

  const handleToggle2FA = () => {
    setTwoFactorEnabled(!twoFactorEnabled);
  };

  return (
    <>
      {/* Page Menu */}
      <div className="c-page-menu">
        <ul>
          <li><Link to="/wallet-finance">Finance</Link></li>
          <li><Link to="/wallet-transactions">Transactions</Link></li>
          <li className="active"><Link to="/wallet-security">Security Settings <span></span></Link></li>
        </ul>
      </div>

      <div className="d-block w-75">
        {/* Section Title */}
        <div className="c-section-title mt-0">
          <div className="d-flex flex-column justify-content-center">
            <h1>
              <img src={getAssetPath("assets/images/security.svg")} alt="" />
              Security Management
            </h1>
            <p className="c-section-title__desc">Monitor and enhance your wallet security</p>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="c-stats-card__container box">
          <div className="c-stats-card">
            <a href="#" className="c-stats-card__hover"><i className="bi bi-arrows-angle-expand"></i></a>
            <div className="c-stats-card__icon"><img src={getAssetPath("assets/images/lock-2.svg")} alt="" /></div>
            <div className="c-stats-card__text">
              <h4 className="mb-md-3 mb-2">2FA Status</h4>
              <label className="c-switch" id="2fa">
                <input 
                  type="checkbox" 
                  className="c-switch-input" 
                  checked={twoFactorEnabled}
                  onChange={handleToggle2FA}
                />
                <span className="c-switch-label" data-on="On" data-off="Off"></span>
                <span className="c-switch-handle"></span>
              </label>
            </div>
          </div>
          <div className="c-stats-card light-blue">
            <a href="#" className="c-stats-card__hover"><i className="bi bi-arrows-angle-expand"></i></a>
            <div className="c-stats-card__icon"><img src={getAssetPath("assets/images/compass.svg")} alt="" /></div>
            <div className="c-stats-card__text">
              <h4>Whitelisted</h4>
              <div className="c-stats-card__text-count align-items-end">47 <h6 className="mb-1 ms-1">Addresses</h6></div>
            </div>
          </div>
        </div>

        {/* Activity Alerts Section */}
        <div className="c-section-title mt-md-5 mt-4">
          <div className="d-flex flex-column justify-content-center">
            <h1>
              <img src={getAssetPath("assets/images/activity.svg")} alt="" />
              Activity Alerts
            </h1>
          </div>
        </div>

        {/* Activity Alert */}
        <div className="c-activity-alert mb-2">
          <div className="c-activity-alert__container">
            <h1>56.89 SOL</h1>
            <p>The payment was made on <b>16 October at 12:00 PM</b></p>
            <div className="c-activity-alert__mask"></div>
            <div className="c-activity-alert__video">
              <video 
                src={getAssetPath("assets/images/radar.mp4")} 
                autoPlay 
                loop 
                muted 
                playsInline
              ></video>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WalletSecurityPage; 